var NotificationStyle;
(function (NotificationStyle) {
    NotificationStyle["INFO"] = "info";
    NotificationStyle["MESSAGE"] = "message";
    NotificationStyle["ALERT"] = "alert";
    NotificationStyle["ERROR"] = "error";
    NotificationStyle["SUCCESS"] = "success";
    NotificationStyle["TOP_NAV_COOKIE"] = "cookie";
    NotificationStyle["POP_MODAL"] = "pop-modal";
})(NotificationStyle || (NotificationStyle = {}));
var NotificationDelay;
(function (NotificationDelay) {
    NotificationDelay[NotificationDelay["SHORT"] = 2500] = "SHORT";
    NotificationDelay[NotificationDelay["DEFAULT"] = 5000] = "DEFAULT";
    NotificationDelay[NotificationDelay["LONG"] = 10000] = "LONG";
    NotificationDelay[NotificationDelay["PERMANENT"] = 10001] = "PERMANENT";
})(NotificationDelay || (NotificationDelay = {}));

export { NotificationDelay, NotificationStyle };
